import Popper from 'popper.js';

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  name: 'PtSidebar',
  props: {
    overlay: {
      type: Boolean,
      default: true,
    },
    partialCollapse: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: 'left',
      description: 'Sidebar position (left/right)',
    },
    visibleInitially: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 300,
    },
    closeOnOutsideClick: {
      type: Boolean,
      default: true,
      description: 'Whether sidebar should be close or not',
    },
  },
  data: function data() {
    return {
      id: Math.random().toString('16').substr(2),
      isVisible: this.visibleInitially,
    };
  },
  provide: function provide() {
    return {
      showSidebar: this.show,
      sidebarId: this.id,
      hideSidebar: this.hide,
      toggleSidebar: this.toggle,
      visibleOnInit: this.visibleInitially,
    };
  },
  computed: {
    getClasses: function getClasses() {
      var obj;

      return ( obj = {
        'pt-sidebar-content': true
      }, obj[("content-" + (this.position))] = true, obj['collapsed'] =  !this.isVisible, obj );
    },
    getStyles: function getStyles() {
      if (this.partialCollapse) {
        return {
          width: this.isVisible ? ((this.width) + "px") : '50px',
          overflow: this.isVisible ? 'auto' : 'hidden',
        };
      }

      var transform = this.position === 'left' ? 'translateX(-100%)' : 'translateX(100%)';

      if (this.isVisible) {
        transform = 'translateX(0px)';
      }

      return {
        width: ((this.width) + "px"),
        overflow: this.isVisible ? 'auto' : 'hidden',
        transform: transform,
        'will-change': 'transform',
      };
    },
  },
  watch: {
    isVisible: function isVisible(value) {
      if (this.overlay) {
        // Hide scroll when overlay is shown
        document.body.style.overflow = value ? 'hidden' : 'auto';
      }
    },
  },
  beforeDestroy: function beforeDestroy() {
    if (this.overlay) {
      // Set overflow back to auto
      document.body.style.overflow = 'auto';
    }
  },
  methods: {
    emitEvent: function emitEvent(isOpen) {
      this.$root.$emit('pt::sidebar::state', { isOpen: isOpen, id: this.id });

      if (isOpen) {
        this.$emit('open', this.id);
      } else {
        this.$emit('close', this.id);
      }
    },
    hide: function hide() {
      this.isVisible = false;
      this.emitEvent(false);
    },
    show: function show() {
      this.isVisible = true;
      this.emitEvent(true);
    },
    toggle: function toggle() {
      this.emitEvent(!this.isVisible);
      this.isVisible = !this.isVisible;
    },
    handleOutsideClick: function handleOutsideClick() {
      if (!this.closeOnOutsideClick) { return; }
      this.hide();
    },
  },
};

function normalizeComponent(compiledTemplate, injectStyle, defaultExport, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, isShadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof isShadowMode === 'function') {
        createInjectorSSR = createInjector;
        createInjector = isShadowMode;
        isShadowMode = false;
    }
    // Vue.extend constructor export interop
    const options = typeof defaultExport === 'function' ? defaultExport.options : defaultExport;
    // render functions
    if (compiledTemplate && compiledTemplate.render) {
        options.render = compiledTemplate.render;
        options.staticRenderFns = compiledTemplate.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (injectStyle) {
                injectStyle.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (injectStyle) {
        hook = isShadowMode
            ? function () {
                injectStyle.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
            }
            : function (context) {
                injectStyle.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return defaultExport;
}

/* script */
            var __vue_script__ = script;
            
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "aside",
    { staticClass: "pt-sidebar" },
    [
      _c(
        "div",
        { class: _vm.getClasses, style: _vm.getStyles },
        [
          _vm.isVisible || _vm.partialCollapse
            ? _vm._t("default", null, {
                isVisible: _vm.isVisible,
                partialCollapse: _vm.partialCollapse
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.isVisible && _vm.overlay
          ? _c("div", {
              staticClass: "pt-sidebar-overlay",
              on: { click: _vm.handleOutsideClick }
            })
          : _vm._e()
      ])
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Sidebar = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var SidebarMixin = {
  name: 'PtSidebarMixin',
  data: function data() {
    return {
      sidebarVisible: this.visibleOnInit,
    };
  },
  inject: ['sidebarId', 'visibleOnInit'],
  mounted: function mounted() {
    this.$root.$on('pt::sidebar::state', this.$_sidebarMixin_handleEvent);
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('pt::sidebar::state', this.$_sidebarMixin_handleEvent);
  },
  methods: {
    $_sidebarMixin_handleEvent: function $_sidebarMixin_handleEvent(ref) {
      var isOpen = ref.isOpen;
      var id = ref.id;

      if (this.sidebarId !== id) { return; }

      this.sidebarVisible = isOpen;

      if (this.onSidebarStateChange) {
        this.onSidebarStateChange(isOpen);
      }
    },
  },
};

//

var script$1 = {
  name: 'PtTooltip',
  props: {
    content: {
      type: String,
      default: '',
      description: 'Content to show in tooltip, tooltip won\'t be shown if content is empty',
    },
    disableOutsideClick: {
      type: Boolean,
      default: false,
      description: 'Disable hiding tooltip on outside click. Only valid if trigger is set to `click`',
    },
    placement: {
      type: String,
      default: 'bottom',
    },
    trigger: {
      type: String,
      default: 'hover',
      validator: function validator(value) {
        return ['hover', 'click'].indexOf(value) !== -1;
      },
      description: 'Trigger event for tooltip. Possible values are `hover`, `click`',
    },
  },
  data: function data() {
    return {
      refElement: null,
      showTooltip: false,
      tooltipInstance: null,
    };
  },
  watch: {
    showTooltip: function showTooltip(value) {
      if (value) {
        this.createOrUpdateTooltip();
      }
    },
  },
  mounted: function mounted() {
    this.refElement = this.$slots.default[0].elm;

    switch (this.trigger) {
      case 'click':
        this.refElement.addEventListener('click', this.doToggle);
        document.addEventListener('click', this.handleDocumentClick);
        break;
      case 'hover':
      default:
        this.refElement.addEventListener('mouseover', this.show);
        this.refElement.addEventListener('mouseout', this.hide);
        break;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.refElement) {
      this.refElement.removeEventListener('click', this.doToggle);
      this.refElement.removeEventListener('mouseover', this.show);
      this.refElement.removeEventListener('mouseout', this.hide);
    }

    document.removeEventListener('click', this.handleDocumentClick);

    if (this.tooltipInstance && this.tooltipInstance.destroy) {
      this.tooltipInstance.destroy();
      this.tooltipInstance = null;
    }

    this.refElement = null;
  },
  methods: {
    createOrUpdateTooltip: function createOrUpdateTooltip() {
      if (this.tooltipInstance) {
        this.tooltipInstance.scheduleUpdate();
      } else {
        this.createTooltipInstance();
      }
    },
    createTooltipInstance: function createTooltipInstance() {
      var tooltipElement = this.$refs.tooltip;
      var options = {
        placement: this.placement,
        modifiers: {
          arrow: {
            enabled: true,
            element: this.$refs.arrow,
          },
        },
        positionFixed: true,
      };

      this.tooltipInstance = new Popper(this.refElement, tooltipElement, options);
    },
    doToggle: function doToggle(e) {
      // User may want to show/hide programmatically
      if (e.defaultPrevented) { return; }

      this.toggle();
    },
    handleDocumentClick: function handleDocumentClick(event) {
      // We don't want to handle this if tooltip is hidden
      if (!this.showTooltip) { return; }

      if ((this.refElement && this.refElement.contains(event.target)) ||
          this.$refs.tooltip.contains(event.target) ||
          this.disableOutsideClick) {
        return;
      }

      this.showTooltip = false;
    },
    show: function show() {
      if (this.content || this.$slots.content) {
        this.showTooltip = true;
      }
    },
    hide: function hide() {
      this.showTooltip = false;
    },
    toggle: function toggle() {
      if (this.content || this.$slots.content) {
        this.showTooltip = !this.showTooltip;
      }
    },
  },
};

/* script */
            var __vue_script__$1 = script$1;
            
/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTooltip,
                expression: "showTooltip"
              }
            ],
            ref: "tooltip",
            staticClass: "pt-tooltip"
          },
          [
            _c(
              "div",
              { staticClass: "pt-tooltip-inner" },
              [
                _vm._t("content", [
                  _vm._v(
                    "\n            " + _vm._s(_vm.content) + "\n          "
                  )
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { ref: "arrow", staticClass: "pt-tooltip-arrow" })
          ]
        )
      ]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  var __vue_inject_styles__$1 = undefined;
  /* scoped */
  var __vue_scope_id__$1 = undefined;
  /* module identifier */
  var __vue_module_identifier__$1 = undefined;
  /* functional template */
  var __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PtTooltip = normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

//

var script$2 = {
  name: 'PtSidebarDropdown',
  components: { PtTooltip: PtTooltip },
  mixins: [SidebarMixin],
  props: {
    iconClass: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    tooltipContent: {
      type: String,
      default: '',
    },
  },
  data: function data() {
    return {
      id: Math.random().toString('16').substr(2),
      showDropdown: false,
      menuHeight: '0px',
    };
  },
  inject: ['showSidebar', 'sidebarId'],
  computed: {
    getStyles: function getStyles() {
      var maxHeight = this.menuHeight === '0px' ? 'none' : this.menuHeight;

      return {
        'max-height': this.showDropdown ? maxHeight : '0px',
      };
    },
  },
  mounted: function mounted() {
    var this$1 = this;

    /**
     * Calculate the dropdown menu height by showing
     * the menu temporarily & then hide it.
     */
    this.showDropdown = true;
    this.$nextTick(function () {
      this$1.menuHeight = (this$1.$refs.menu.clientHeight) + "px";
      this$1.showDropdown = false;
    });

    this.$root.$on('pt::sidebar::dropdown::open', this.handleEvent);
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('pt::sidebar::dropdown::open', this.handleEvent);
  },
  methods: {
    handleEvent: function handleEvent(ref) {
      var dropdownId = ref.dropdownId;
      var sidebarId = ref.sidebarId;

      if (this.sidebarId !== sidebarId) { return; }

      if (this.id !== dropdownId && this.showDropdown) {
        this.showDropdown = false;
      }
    },
    onSidebarStateChange: function onSidebarStateChange(isOpen) {
      if (!isOpen) {
        // Sidebar closed, close the dropdown
        this.showDropdown = false;
      }
    },
    toggleDropdown: function toggleDropdown() {
      if (!this.sidebarVisible) {
        this.showSidebar();
      }

      /**
       * Emit dropdown open event so that we can close other
       * opened dropdown by checking the dropdown id.
       */
      if (!this.showDropdown) {
        this.$root.$emit('pt::sidebar::dropdown::open', {
          dropdownId: this.id,
          sidebarId: this.sidebarId,
        });
      }

      this.showDropdown = !this.showDropdown;
    },
  },
};

/* script */
            var __vue_script__$2 = script$2;
            
/* template */
var __vue_render__$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("li", { ref: "dropdown", staticClass: "pt-sidebar-dropdown" }, [
    _c(
      "div",
      {
        staticClass: "label-container",
        attrs: { role: "button" },
        on: { click: _vm.toggleDropdown }
      },
      [
        !!_vm.iconClass
          ? _c(
              "div",
              { staticClass: "item-icon" },
              [
                !_vm.sidebarVisible && !!_vm.tooltipContent
                  ? _c(
                      "pt-tooltip",
                      {
                        attrs: {
                          content: _vm.tooltipContent,
                          placement: "right"
                        }
                      },
                      [_c("i", { staticClass: "fa", class: _vm.iconClass })]
                    )
                  : _c("i", { staticClass: "fa", class: _vm.iconClass })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "item-name" }, [
          _c("span", [_vm._v(_vm._s(_vm.label))]),
          _vm._v(" "),
          _c("i", {
            staticClass: "fa fa-caret-down",
            class: _vm.showDropdown && "opened"
          })
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "ul",
      { ref: "menu", staticClass: "dropdown-menu", style: _vm.getStyles },
      [_vm._t("default")],
      2
    )
  ])
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  var __vue_inject_styles__$2 = undefined;
  /* scoped */
  var __vue_scope_id__$2 = undefined;
  /* module identifier */
  var __vue_module_identifier__$2 = undefined;
  /* functional template */
  var __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var SidebarDropdown = normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    undefined,
    undefined
  );

//

var script$3 = {
  name: 'PtSidebarHeader',
  mixins: [SidebarMixin],
  props: {
    href: {
      type: String,
      default: '/',
    },
    logo: {
      type: [Number, String],
      required: true,
    },
    to: {
      type: [String, Object],
      default: '',
      description: 'Navigation url in string/object to use with router-link',
    },
  },
  inject: ['toggleSidebar'],
  computed: {
    isRouter: function isRouter() {
      return Boolean(this.$router) && !!this.to;
    },
  },
};

/* script */
            var __vue_script__$3 = script$3;
            
/* template */
var __vue_render__$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "pt-sidebar-header" },
    [
      _c("div", { staticClass: "hamburger" }, [
        _c(
          "div",
          {
            class: { menu: true, open: _vm.sidebarVisible },
            attrs: { role: "button" },
            on: { click: _vm.toggleSidebar }
          },
          [
            _c("span"),
            _vm._v(" "),
            _c("span"),
            _vm._v(" "),
            _c("span"),
            _vm._v(" "),
            _c("span")
          ]
        )
      ]),
      _vm._v(" "),
      _vm.isRouter
        ? _c(
            "router-link",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.sidebarVisible,
                  expression: "sidebarVisible"
                }
              ],
              staticClass: "logo",
              attrs: { to: _vm.to }
            },
            [_c("img", { attrs: { src: _vm.logo } })]
          )
        : _c(
            "a",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.sidebarVisible,
                  expression: "sidebarVisible"
                }
              ],
              staticClass: "logo",
              attrs: { href: _vm.href }
            },
            [_c("img", { attrs: { src: _vm.logo } })]
          )
    ],
    1
  )
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  var __vue_inject_styles__$3 = undefined;
  /* scoped */
  var __vue_scope_id__$3 = undefined;
  /* module identifier */
  var __vue_module_identifier__$3 = undefined;
  /* functional template */
  var __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var SidebarHeader = normalizeComponent(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    undefined,
    undefined
  );

//
//
//
//
//
//

var script$4 = {
  name: 'PtSidebarMenu',
};

/* script */
            var __vue_script__$4 = script$4;
            
/* template */
var __vue_render__$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("ul", { staticClass: "pt-sidebar-menu" }, [_vm._t("default")], 2)
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;

  /* style */
  var __vue_inject_styles__$4 = undefined;
  /* scoped */
  var __vue_scope_id__$4 = undefined;
  /* module identifier */
  var __vue_module_identifier__$4 = undefined;
  /* functional template */
  var __vue_is_functional_template__$4 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var SidebarMenu = normalizeComponent(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    undefined,
    undefined
  );

//

var script$5 = {
  name: 'PtSidebarMenuItem',
  components: { PtTooltip: PtTooltip },
  mixins: [SidebarMixin],
  props: {
    active: {
      type: Boolean,
      default: false,
      description: 'Whether the route is active or not, only use if `router-link` is not used',
    },
    click: {
      type: Function,
      default: null,
    },
    href: {
      type: String,
      default: '',
    },
    iconClass: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    to: {
      type: [String, Object],
      default: '',
      description: 'Navigation url in string/object to use with router-link',
    },
    tooltipContent: {
      type: String,
      default: '',
    },
  },
  inject: ['hideSidebar'],
  computed: {
    isRouter: function isRouter() {
      return Boolean(this.$router) && !!this.to;
    },
  },
  methods: {
    handleClick: function handleClick(e) {
      this.hideSidebar();

      if (this.click) {
        this.click(e);
      }
    },
  },
};

/* script */
            var __vue_script__$5 = script$5;
            
/* template */
var __vue_render__$5 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "li",
    { staticClass: "pt-sidebar-menu-item" },
    [
      _vm.isRouter
        ? _c(
            "router-link",
            {
              attrs: {
                to: _vm.to,
                role: "menuitem",
                "active-class": "pt-sidebar-menu-item-active",
                "exact-active-class": "pt-sidebar-menu-item-exact-active"
              },
              nativeOn: {
                click: function($event) {
                  return _vm.handleClick($event)
                }
              }
            },
            [
              !!_vm.iconClass
                ? _c(
                    "div",
                    { staticClass: "item-icon" },
                    [
                      !_vm.sidebarVisible && !!_vm.tooltipContent
                        ? _c(
                            "pt-tooltip",
                            {
                              attrs: {
                                content: _vm.tooltipContent,
                                placement: "right"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa",
                                class: _vm.iconClass
                              })
                            ]
                          )
                        : _c("i", { staticClass: "fa", class: _vm.iconClass })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "item-name" }, [
                _c("span", [_vm._v(_vm._s(_vm.label))])
              ])
            ]
          )
        : _c(
            "a",
            {
              class: {
                "pt-sidebar-menu-item-active": _vm.active,
                "pt-sidebar-menu-item-exact-active": _vm.active
              },
              attrs: { href: _vm.href, role: "menuitem" },
              on: { click: _vm.handleClick }
            },
            [
              !!_vm.iconClass
                ? _c(
                    "div",
                    { staticClass: "item-icon" },
                    [
                      !_vm.sidebarVisible && !!_vm.tooltipContent
                        ? _c(
                            "pt-tooltip",
                            {
                              attrs: {
                                content: _vm.tooltipContent,
                                placement: "right"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa",
                                class: _vm.iconClass
                              })
                            ]
                          )
                        : _c("i", { staticClass: "fa", class: _vm.iconClass })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "item-name" }, [
                _c("span", [_vm._v(_vm._s(_vm.label))])
              ])
            ]
          )
    ],
    1
  )
};
var __vue_staticRenderFns__$5 = [];
__vue_render__$5._withStripped = true;

  /* style */
  var __vue_inject_styles__$5 = undefined;
  /* scoped */
  var __vue_scope_id__$5 = undefined;
  /* module identifier */
  var __vue_module_identifier__$5 = undefined;
  /* functional template */
  var __vue_is_functional_template__$5 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var SidebarMenuItem = normalizeComponent(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    undefined,
    undefined
  );

export { Sidebar as PtSidebar, SidebarDropdown as PtSidebarDropdown, SidebarHeader as PtSidebarHeader, SidebarMenu as PtSidebarMenu, SidebarMenuItem as PtSidebarMenuItem };
